import React from 'react';
import i18next from 'i18next';
import en from './i18n/en';
import jp from './i18n/jp';

i18next.addResourceBundle('en', 'multipleCompaniesPage', en);
i18next.addResourceBundle('jp', 'multipleCompaniesPage', jp);

const MemberConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/multipleCompanies',
			exact: true,
			component: React.lazy(() => import('./MultipleCompanies'))
		}
	]
};

export default MemberConfig;
